import { Spin } from 'antd'
import Flex from 'components/Flex'
import {
  FilterWrapper,
  RowNumberDataReport,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import FilterCheckBoxComp from 'components/UIComponents/ReportSearchFilter/FilterCheckBox/FilterCheckBox.js'
import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
const CityFilter = ({
  setValue,
  value,
  search,
  cityDetails,
  cityData,
  valueParam,
  labelParam,
  loading,
  setLoading,
  flag,
  batch,
  length,
}) => {
  const [citiesData, setCitiesData] = useState([])
  const [debounced, setDebounced] = useState(() => search)
  const [load, setLoad] = useState(false)
  const [page, setPage] = useState(1)
  const getCities = (search = '') => {
    let city = search
    if (flag !== '' && flag) {
      cityDetails(setLoading, city, flag, 0, setLoad)
    } else {
      cityDetails(setLoading, city, 0, setLoad)
    }
  }
  useEffect(() => {
    setCitiesData([])
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(search)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [search])

  useEffect(() => {
    setCitiesData([])

    getCities(search)
  }, [debounced])
  const uniqueItems = new Set()

  useEffect(() => {
    if (cityData?.result?.length) {
      let newList = [...(cityData?.result ?? [])]
      let uniqueList = Array.from(
        new Map(newList.map(item => [JSON.stringify(item), item])).values()
      ).map(item => {
        const updatedItem = { ...item }

        if (updatedItem?.education_level) {
          updatedItem.education_level_value = updatedItem?.education_level

          const educationLevel = updatedItem?.education_level.toUpperCase()

          if (!uniqueItems.has(educationLevel)) {
            updatedItem.education_level = educationLevel
            uniqueItems.add(educationLevel)
          } else {
            updatedItem.education_level = null // Or any other value to indicate duplication
          }
        }

        return updatedItem
      })
      let data = uniqueList?.filter(item => item.education_level !== null)
      let finalData = []

      if (page > 1) {
        finalData = [...citiesData, ...data]
      } else {
        finalData = data
      }
      setCitiesData(finalData)
    }
  }, [cityData])

  const onChange = checkedValue => {
    const locationCopy = [...value]
    const indexToRemove = value.indexOf(...checkedValue)

    if (indexToRemove !== -1) {
      locationCopy.splice(indexToRemove, 1)
      setValue(locationCopy)
    } else {
      setValue(batch ? checkedValue : [...value, ...checkedValue])
    }
  }

  const Spinner = (
    <>
      {load ? (
        <Spin />
      ) : (!citiesData.length && !loading) || !cityData?.result?.length > 0 ? (
        <RowNumberDataReport>No Data Found</RowNumberDataReport>
      ) : (
        ''
      )}
    </>
  )
  const loadMoreData = async () => {
    let pageNumber = cityData?.page ? cityData?.page + 1 : 0
    cityDetails(setLoading, search, flag, pageNumber, setLoad)
    setPage(page + 1)
  }
  return (
    <FilterWrapper>
      <InfiniteScroll
        key={cityData}
        dataLength={citiesData?.length}
        height="167px"
        next={loadMoreData}
        hasMore={citiesData.length < cityData?.count}
        loader={
          <Flex center>
            <Spin small />
          </Flex>
        }
      >
        {!loading && length > 0 && (
          <FilterCheckBoxComp
            gap={'1rem'}
            options={citiesData}
            value={value}
            onChangeCheck={e => onChange([e.target.value])}
            valueParam={valueParam}
            labelParam={labelParam}
          />
        )}
        <Flex center>{Spinner}</Flex>
      </InfiniteScroll>
    </FilterWrapper>
  )
}

export default CityFilter
